import React from "react";
import PropTypes from "prop-types";

import { RadioButton } from "primereact/radiobutton";

const AddressType = (props) => {
  let { data, handleToggle, disableTrade, disablePhysical } = props;
  return (
    <>
      <div className="col-6 remove-address">
        <div
          className={`address-card ${disablePhysical && "address-card-disabled"}`}
        >
          <div className="flex align-items-center item-gap">
            <RadioButton
              inputId="ingredient1"
              name="type"
              value="Physical"
              disabled={disablePhysical}
              onChange={() => handleToggle(data.id, "Physical")}
              checked={data.type === "Physical"}
            />
            <label htmlFor="ingredient1" className="ml-3">
              <div className="flex flex-column justify-content-start">
                <p className="address-card-para">Physical Office Address</p>
                <p className="address-radio-para">
                  Location of daily operations.
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div className="col-6  remove-address">
        <div
          className={`address-card ${disableTrade && "address-card-disabled"}`}
        >
          <div className="flex align-items-center item-gap">
            <RadioButton
              inputId="ingredient2"
              name="type"
              value="Trading"
              disabled={disableTrade}
              onChange={() => handleToggle(data.id, "Trading")}
              checked={data.type === "Trading"}
            />
            <label htmlFor="ingredient2" className="ml-3">
              <div className="flex flex-column justify-content-start">
                <p className="address-card-para">Trading Address</p>
                <p className="address-radio-para">
                  Address used for business/customer interaction.
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
AddressType.propTypes = {
  handleToggle: PropTypes.func,
  data: PropTypes.object,
};

export default AddressType;
